export default __webpack_public_path__ + "static/media/Future Learn Learn to Code For web P2.0beeb69d.webp";